
import { useState } from "react";
import styles from "components/header/Header.module.css";
import { FaArrowAltCircleRight } from "react-icons/fa";
import LoginPopup from "../popups/LoginPopup";
import RegistrierenPopup from "../popups/RegistrierenPopup";
import { smoothScrollPolyfill } from "utils/smoothScroll";


interface Section {
  id: string;
  label: string;
}

interface HeaderProps {
  sections: Section[];
}

export default function LandingHeaderComponent({ sections }: HeaderProps) {
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  const [isRegisterPopupOpen, setIsRegisterPopupOpen] = useState(false);

  const handleScroll = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - 100;
      smoothScrollPolyfill(offsetPosition, 1000);
    }
  };

  const toggleLoginPopup = () => {
    setIsLoginPopupOpen(!isLoginPopupOpen);
    if (isRegisterPopupOpen) setIsRegisterPopupOpen(false);
  };

  const toggleRegisterPopup = () => {
    setIsRegisterPopupOpen(!isRegisterPopupOpen);
    if (isLoginPopupOpen) setIsLoginPopupOpen(false);
  };



  // const handleLoginSuccess = () => {
  //   setIsLoggedIn(true);
  //   setIsLoginPopupOpen(false); 
  // };

  return (
    <>
      <nav className={styles.middel_col}>
        <ul className={styles.middel_col_grid}>
          {sections.map((section) => (
            <li
              key={section.id}
              className={styles.middel_col_grid_item}
              onClick={() => handleScroll(section.id)}
            >
              {section.label}
            </li>
          ))}
        </ul>
      </nav>
      <div className={styles.right_col}>
        <button className={styles.loginButton} onClick={toggleLoginPopup}>
          <span>Login</span>
          <FaArrowAltCircleRight className={styles.icon} />
        </button>
      </div>
      <LoginPopup
        isOpen={isLoginPopupOpen}
        onClose={toggleLoginPopup}
        togglePopup={toggleRegisterPopup}
      />
      <RegistrierenPopup
        isOpen={isRegisterPopupOpen}
        onClose={toggleRegisterPopup}
        togglePopup={toggleLoginPopup}
      />
    </>
  );
}
